import { render } from "./manage_documents.html?vue&type=template&id=81c201a6&external"
import script from "./manage_documents.js?vue&type=script&lang=js&external"
export * from "./manage_documents.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__